import type React from 'react';
import { ShiftAuthProvider } from './contexts/ShiftAuthProvider';
import { ShiftRouter } from './routes/ShiftRouter';
import { ShiftEventsProvider } from './contexts/ShiftEventsProvider';
import { ShiftPwaProvider } from './components/ShiftPwaControls';

export const App: React.FC = () => (
  <ShiftAuthProvider>
    <ShiftEventsProvider>
      <ShiftPwaProvider>
        <ShiftRouter />
      </ShiftPwaProvider>
    </ShiftEventsProvider>
  </ShiftAuthProvider>
);
